import React from "react";
import { SerializedStyles } from "@emotion/react";

export interface LogoProps {
	showOnlyIcon?: boolean;
	isMonochrome?: boolean;
	height?: number | string;
	className: string;
	/**
	 * Emotion CSS style if any
	 */
	css?: SerializedStyles;
	/**
	 * Optional click handler
	 */
	onClick?: () => void;
}

const LogoDefaultProps = {
	showOnlyIcon: false,
	isMonochrome: false,
	height: "100%",
};

/**
 * Crusher Logo component
 */
export const Logo: React.FC<LogoProps> = ({ showOnlyIcon=false, isMonochrome, height=23, ...props }) => {

	return (
	  <svg
		width={showOnlyIcon ? (height) : (113)}
		height={height}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	  >
		<path
		  d="M46.982 9.29c-.855-1.026-1.91-1.539-3.167-1.539-.553 0-1.069.1-1.546.297-.465.198-.868.47-1.207.815-.34.334-.61.736-.81 1.205a4.04 4.04 0 00-.283 1.52c0 .556.094 1.069.282 1.538.202.47.472.877.811 1.223.352.346.76.618 1.226.816.465.197.967.296 1.508.296 1.181 0 2.243-.494 3.186-1.482v4.3l-.377.129c-.566.197-1.094.34-1.584.426-.49.099-.974.148-1.452.148-.98 0-1.922-.179-2.827-.537a7.74 7.74 0 01-2.376-1.538 7.888 7.888 0 01-1.64-2.354c-.415-.914-.622-1.909-.622-2.984s.201-2.057.603-2.946a7.417 7.417 0 011.64-2.317 7.415 7.415 0 012.395-1.52 7.438 7.438 0 012.846-.556 7.42 7.42 0 011.66.186c.552.11 1.13.29 1.734.537V9.29zM48.999 9.086h3.412v1.557c.364-.569.81-1.001 1.338-1.298.528-.309 1.144-.463 1.848-.463h.283c.113 0 .238.012.377.037v3.206a3.288 3.288 0 00-1.47-.333c-.793 0-1.39.234-1.792.704-.39.457-.584 1.13-.584 2.02v4.077h-3.412V9.086zM61.193 9.086v5.356c0 1.174.578 1.76 1.734 1.76 1.156 0 1.734-.586 1.734-1.76V9.086h3.412v6.005c0 1.284-.433 2.248-1.3 2.89-.855.643-2.137.964-3.846.964-1.71 0-2.998-.32-3.865-.963-.854-.643-1.282-1.607-1.282-2.891V9.085h3.413zM76.8 11.532c-.627-.321-1.243-.482-1.847-.482-.314 0-.571.062-.773.186a.571.571 0 00-.282.5c0 .111.012.204.037.278a.614.614 0 00.208.185c.113.062.27.118.471.167.214.05.49.111.83.186.942.185 1.646.518 2.111 1 .465.47.697 1.075.697 1.816 0 .556-.113 1.057-.339 1.502-.226.444-.54.821-.942 1.13a4.486 4.486 0 01-1.452.686 6.36 6.36 0 01-1.866.26c-1.308 0-2.596-.365-3.865-1.094l1.244-2.372c.955.642 1.86.963 2.715.963.314 0 .572-.068.773-.204.2-.135.301-.308.301-.518a.658.658 0 00-.056-.297.397.397 0 00-.189-.222 1.298 1.298 0 00-.452-.186 6.635 6.635 0 00-.754-.185c-1.056-.21-1.797-.519-2.225-.927-.414-.42-.622-.994-.622-1.723 0-.531.1-1.007.302-1.427.2-.433.49-.797.867-1.094.377-.296.83-.525 1.357-.685a6.27 6.27 0 011.791-.241c1.069 0 2.105.204 3.11.611l-1.15 2.187zM79.983 3.21h3.412v7.08c.465-.556.936-.926 1.414-1.111.478-.198 1.037-.297 1.678-.297 1.219 0 2.136.334 2.752 1 .629.656.943 1.545.943 2.67v6.041H86.77v-4.8c0-.482-.038-.87-.114-1.167-.075-.297-.2-.525-.377-.686a1.62 1.62 0 00-1.093-.39c-.578 0-1.024.174-1.338.52-.302.333-.453.815-.453 1.445v5.078h-3.412V3.211zM99.571 12.459a2.013 2.013 0 00-.697-1.13c-.352-.285-.78-.427-1.282-.427-.528 0-.962.136-1.3.408-.328.272-.535.655-.623 1.149h3.902zm-3.996 1.946c0 1.445.69 2.168 2.073 2.168.742 0 1.301-.296 1.678-.89h3.299c-.666 2.175-2.331 3.262-4.995 3.262a6.826 6.826 0 01-2.244-.352 5.247 5.247 0 01-1.753-1.038 4.642 4.642 0 01-1.112-1.594c-.264-.617-.396-1.31-.396-2.075 0-.79.126-1.501.377-2.131a4.48 4.48 0 011.074-1.631 4.681 4.681 0 011.678-1.02c.666-.247 1.414-.37 2.244-.37.816 0 1.552.123 2.205.37.654.235 1.207.581 1.659 1.038.453.457.798 1.02 1.037 1.687.239.654.358 1.396.358 2.224v.352h-7.182zM104.708 9.086h3.412v1.557c.364-.569.811-1.001 1.338-1.298.528-.309 1.144-.463 1.848-.463h.283c.113 0 .239.012.377.037v3.206a3.291 3.291 0 00-1.471-.333c-.791 0-1.388.234-1.791.704-.389.457-.584 1.13-.584 2.02v4.077h-3.412V9.086z"
		  fill="#fff"
		/>
		<path
		  d="M0 5.75A5.75 5.75 0 015.75 0h11.352a5.75 5.75 0 015.75 5.75v11.5a5.75 5.75 0 01-5.75 5.75H5.75A5.75 5.75 0 010 17.25V5.75z"
		  fill="url(#prefix__paint0_linear_7131_5874)"
		/>
		<path
		  d="M4.231 7.487a.69.69 0 00-.781.684v4.897c0 .418.368.74.781.684l3.447-.462a.69.69 0 00.598-.684V8.633a.69.69 0 00-.598-.684l-3.447-.462zM14.021 16.102h-3.243a.46.46 0 00-.46.46v5.968c0 .254.206.46.46.46h3.243a.46.46 0 00.46-.46v-5.968a.46.46 0 00-.46-.46z"
		  fill="#fff"
		/>
		<path
		  d="M19.97 14.7c-.14-4.274-2.847-7.317-6.18-7.317h-2.84a.46.46 0 00-.146.023l-1.559.52a.46.46 0 00-.314.436v4.648c0 .128.053.25.146.337l1.034.964a.57.57 0 01.208.453v1.872c0 .254.206.46.46.46h3.246a.46.46 0 00.46-.46v-2.001c0-.048 0-.13.027-.196.02-.047.054-.086.078-.13l.38-.71c.14-.26.348-.389.626-.389 1.527.065 2.985.583 4.096 1.62.148.165.277.074.277-.13z"
		  fill="#fff"
		/>
		{isMonochrome ? (<defs>
		  <linearGradient
			id="prefix__paint0_linear_7131_5874"
			x1={11.426}
			y1={0}
			x2={11.426}
			y2={23}
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="#393939" />
			<stop offset={1} stopColor="#393939" />
		  </linearGradient>
		</defs>) : (<defs>
		  <linearGradient
			id="prefix__paint0_linear_7131_5874"
			x1={11.426}
			y1={0}
			x2={11.426}
			y2={23}
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="#A284FA" />
			<stop offset={1} stopColor="#711BFE" />
		  </linearGradient>
		</defs>)}
		
	  </svg>
	)
};

Logo.defaultProps = LogoDefaultProps;
